// Utilities related to our point-in-time entity snapshots. The idea is that these snapshots adhere to the
// same interface as the corresponding live entity, just with a different keying strategy that includes
// ChangeId in the key.

export const CHANGE_ID_KEY = "ChangeId";
export type CHANGE_ID_KEY = typeof CHANGE_ID_KEY;

export type OptChangeId = { [K in CHANGE_ID_KEY]? : number };

export type ReqChangeId<T extends OptChangeId> = T & { [K in CHANGE_ID_KEY] : number };

export type HasChangeIdSignal = { [K in CHANGE_ID_KEY] : () => number };

export function makePITKey<T extends HasChangeIdSignal>(upstreamKey : (obj : T) => string | number) {
    return (obj : T) => upstreamKey(obj) + '\u2618' + obj[CHANGE_ID_KEY]();
}

export function makePITDataKey<T extends OptChangeId>(upstreamKey : (obj : T) => string | number) {
    return (obj : ReqChangeId<T>) => upstreamKey(obj) + '\u2618' + obj[CHANGE_ID_KEY];
}



// WEBPACK FOOTER //
// ./data/models/PITUtils.ts